import { render, staticRenderFns } from "./myfooter.vue?vue&type=template&id=0d32b021&scoped=true&"
import script from "./myfooter.vue?vue&type=script&lang=js&"
export * from "./myfooter.vue?vue&type=script&lang=js&"
import style0 from "./myfooter.vue?vue&type=style&index=0&id=0d32b021&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d32b021",
  null
  
)

export default component.exports